import { setContext, ContextSetter } from 'apollo-link-context';
import gql from 'graphql-tag';
import { DocumentNode } from 'graphql';
import hmacSHA1 from 'crypto-js/hmac-sha1';
import Base64 from 'crypto-js/enc-base64';
import { UNDERGRADUATE_CATEGORY_SLUG } from '@/helpers/category';
import SentryClient from '@/helpers/sentry';
import { createQueryAndMutateFunctions } from './common';

export const eponaAuth: ContextSetter = (_, { headers }) => {
  const token = localStorage.getItem('token');

  if (token) {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token.replace(/"/g, '')}`,
      },
    };
  }
  return headers;
};

export const { query } = createQueryAndMutateFunctions(
  process.env.VUE_APP_EPONA_STELLATE,
  setContext(eponaAuth),
);

export const eponaQuery = (queryString: DocumentNode, variables?: { [key: string]: any }) =>
  query(queryString, {
    ...variables,
    // Used to distinguish Stellate cache by user
    t: Base64.stringify(hmacSHA1(window.POCKET.profile()?.id.toString(), 'epo')),
  });

export const getUserEnrollmentsQuery = gql`
  query getUserEnrollments {
    getUserEnrollments {
      identifier
      message
      data {
        id
        course {
          id
          name
          slug
        }
      }
    }
  }
`;

export const getUndergradContractsFromEpona = async (): Promise<any[]> => {
  try {
    const { data } = await eponaQuery(getUserEnrollmentsQuery);

    return data.getUserEnrollments.data.map(({ id, course }: any) => ({
      id,
      courseByCourseId: {
        ...course,
        id,
        descomplicaCourseId: course.id,
        descomplicaCategorySlug: UNDERGRADUATE_CATEGORY_SLUG,
      },
    }));
  } catch (e) {
    SentryClient.captureError(e);

    return [];
  }
};
